
// import React from 'react'
// import api from '../api'

// export default function Menu(){
//   const [items,setItems]=React.useState([]);
//   const [name,setName]=React.useState(''); const [price,setPrice]=React.useState('');

//   React.useEffect(()=>{ load(); },[]);
//   async function load(){ const r = await api.get('/menu'); setItems(r.data); }

//   async function add(e){ e.preventDefault(); await api.post('/menu',{name,price: Number(price)}); setName(''); setPrice(''); await load(); }
//   async function del(id){ if(!confirm('Delete?')) return; await api.delete('/menu/'+id); await load(); }
//   return (
//     <div>
//       <h2 className="text-2xl font-bold mb-4">Menu</h2>
//       <form onSubmit={add} className="mb-4 flex gap-2">
//         <input className="border p-2" placeholder="Name" value={name} onChange={e=>setName(e.target.value)} />
//         <input className="border p-2" placeholder="Price" value={price} onChange={e=>setPrice(e.target.value)} />
//         <button className="bg-blue-600 text-white px-3 py-2 rounded">Add</button>
//       </form>
//       <div className="grid grid-cols-3 gap-3">
//         {items.map(i=> (
//           <div key={i._id} className="bg-white p-3 rounded shadow">
//             <div className="font-bold">{i.name}</div>
//             <div>₹ {i.price}</div>
//             <div className="mt-2">
//               <button className="bg-red-500 text-white px-2 py-1 rounded" onClick={()=>del(i._id)}>Delete</button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   )
// }


import React, { useState, useEffect } from 'react';
import api from '../api';

export default function Menu() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ name: '', price: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadMenu();
  }, []);

  const loadMenu = async () => {
    try {
      const res = await api.get('/menu');
      setItems(res.data);
    } catch (err) {
      console.error(err);
      setError('Failed to load menu items');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      if (!form.name.trim() || !form.price) {
        setError('Please enter valid name and price');
        setLoading(false);
        return;
      }

      await api.post('/menu', { name: form.name.trim(), price: Number(form.price) });
      setForm({ name: '', price: '' });
      await loadMenu();
    } catch (err) {
      console.error(err);
      setError('Failed to add menu item');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this item?')) return;

    try {
      await api.delete(`/menu/${id}`);
      await loadMenu();
    } catch (err) {
      console.error(err);
      setError('Failed to delete menu item');
    }
  };

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">Menu</h2>

      {error && (
        <div className="bg-red-100 text-red-700 px-3 py-2 rounded mb-3 text-sm">
          {error}
        </div>
      )}

      <form onSubmit={handleAdd} className="mb-6 flex gap-2">
        <input
          name="name"
          placeholder="Name"
          value={form.name}
          onChange={handleChange}
          className="border p-2 rounded flex-1"
          required
        />
        <input
          name="price"
          type="number"
          placeholder="Price"
          value={form.price}
          onChange={handleChange}
          className="border p-2 rounded w-28"
          required
        />
        <button
          type="submit"
          disabled={loading}
          className={`bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          {loading ? 'Adding...' : 'Add'}
        </button>
      </form>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        {items.map(item => (
          <div key={item._id} className="bg-white p-4 rounded shadow flex flex-col justify-between">
            <div>
              <div className="font-semibold text-lg">{item.name}</div>
              <div className="text-gray-600 mt-1">₹ {item.price}</div>
            </div>
            <button
              onClick={() => handleDelete(item._id)}
              className="mt-3 bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
            >
              Delete
            </button>
          </div>
        ))}
        {items.length === 0 && <p className="text-gray-500 col-span-full text-center">No menu items yet</p>}
      </div>
    </div>
  );
}
